// eslint-disable-next-line import/prefer-default-export
export const userRoleGroups = {
  CISO: 'CISO',
  SP: 'SP',
};
